/* RepeatDateOfMonthComponent.js */

"use strict";
const Renderer = require("./RepeatDateOfMonthRenderer");
const BaseScheduleComponent = require("../../base/BaseScheduleComponent");

class RepeatDateOfMonthComponent extends BaseScheduleComponent {
    constructor(scheduleComp) {
        super(Renderer, scheduleComp);
    }
    setDefaultScheduleType(type, wasSetByUser) {
        super.setSchedule(RepeatDateOfMonthComponent.defaultValue(type), wasSetByUser);
    }
    static defaultValue() {
        let now = new Date();
        return {
            type: "dom",
            tz: Intl.DateTimeFormat().resolvedOptions().timeZone,
            every: 1,
            dom: 1,
            time: {
                hour: 12,
                minute: 0,
            },
            start: {
                year: now.getFullYear(),
                month: now.getMonth(),
                date: now.getDate(),
            },
        };
    }
}
module.exports = RepeatDateOfMonthComponent;
